module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2VG9R"))).then(() => parcelRequire('fThBo'));